// extracted by mini-css-extract-plugin
module.exports = {"action":"actionsColumn_action__2_mg4"};